import React, { Fragment, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import starSvg from "../../assests/images/star.svg";
import renderStarImages from "../../hooks/RenderStar";
import { specificationsData } from "../../utils/FormData";
import "./success.scss";
const Success = () => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page: "/form/success",
    });
    window.dataLayer.push({
      event: "leads",
      page: "/form/success",
    });
  }, []);
  return (
    <Fragment>
      <div className="success">
        <div className="success__info">
          <div className="container">
            <div className="form-rating">
              Excellent <span>{renderStarImages(5)}</span>
              1,378+ <span>Reviews On</span>
              <span>
                <LazyLoadImage className="star" src={starSvg} alt="alt" />
              </span>{" "}
              TrustPilot
            </div>
            <h2 className="title">
              <span className="sp1">
                We've successfully received your request,{" "}
              </span>
              & Our team will reach out
              <span className="sp2">&nbsp;shortly.</span>
            </h2>
            <p className="note">*Please make sure to have your phone nearby*</p>
          </div>
        </div>

        <div className="success__specifications">
          <div className="container">
            {specificationsData?.map((data) => {
              return (
                <div className="type" key={data?.id}>
                  <img src={data?.image} alt="icon" />
                  <h5>{data?.title}</h5>
                  <p dangerouslySetInnerHTML={{ __html: data?.desc }}></p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Success;
